import { SCHEMA_VERSION } from '~/config';
import { i18nStore } from '../stores/i18nStore';
import { logger } from './logger';
import { notifyFailure } from './notificationUtilities';
export let PaginatedLoadingState = /*#__PURE__*/function (PaginatedLoadingState) {
  PaginatedLoadingState[PaginatedLoadingState["UNINITIALIZED"] = 0] = "UNINITIALIZED";
  PaginatedLoadingState[PaginatedLoadingState["LOADING"] = 1] = "LOADING";
  PaginatedLoadingState[PaginatedLoadingState["LOADING_MORE"] = 2] = "LOADING_MORE";
  PaginatedLoadingState[PaginatedLoadingState["LOADED"] = 3] = "LOADED";
  return PaginatedLoadingState;
}({});
export function withVersionHeaders(apiVersion = '1') {
  return {
    headers: {
      Version: apiVersion,
      SchemaVersion: SCHEMA_VERSION
    }
  };
}
export function selectPaginatedProjectons({
  data
}) {
  return data.results.map(({
    projection
  }) => projection);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleNetworkWarning(error) {
  if (error.response) {
    const code = error.response.status;
    logger.warn(`SERVER [${code}]: ${error.response.data.message}`);
    // TODO: Display a warning toast (maybe?)
  } else {
    logger.warn(`SERVER: ${error.message}`);
    // TODO: Display a warning toast (maybe?)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleNetworkError(error) {
  if (error.response) {
    const code = error.response.status;
    logger.error(`SERVER [${code}]: ${error.response.data && error.response.data.message || undefined}`);
    let errorText;
    try {
      errorText = i18nStore.getState().i18nStaticCache.networkErrors[String(code)];
    } catch {
      errorText = i18nStore.getState().i18nStaticCache.notifications.genericError;
    }
    notifyFailure(errorText);
    return;
  }
  logger.error(`ERROR: ${JSON.stringify(error)}`);
  notifyFailure(i18nStore.getState().i18nStaticCache.notifications.genericError);
}